
/**
 * Utility functions for handling profile data
 */
import { logger } from '@/utils/logger';

export function clearProfileCache() {
  const keysToRemove: string[] = [];
  
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (
      key.includes('profile') || 
      key.includes('realtime') || 
      key.includes('connection') || 
      key.includes('supabase')
    )) {
      keysToRemove.push(key);
    }
  }
  
  keysToRemove.forEach(key => {
    logger.debug(`Clearing localStorage key: ${key}`);
    localStorage.removeItem(key);
  });
  
  try {
    sessionStorage.clear();
    logger.debug("Cleared session storage");
  } catch (e) {
    logger.error("Error clearing session storage:", e);
  }
  
  logger.debug(`Cleared ${keysToRemove.length} profile-related items from localStorage`);
  return keysToRemove.length;
}

export function formatUserId(userId: string): string {
  if (!userId) return 'Unknown User';
  return `${userId}`;
}

export function triggerProfileRefresh() {
  const timestamp = new Date().toISOString();
  localStorage.setItem('profile_refresh_trigger', timestamp);
  window.dispatchEvent(new CustomEvent('profile-refresh', { detail: { timestamp } }));
  logger.debug(`🔄 Triggered profile refresh at ${timestamp}`);
  return timestamp;
}
